class Course {
	constructor(){
        this.selector = 'div.formation__courses';
        this.emptyState = '.empty-state';
        this.defaultCountry = 'ES';
        this.max_courses_to_show = 9;
        this.arr_filters = [
            '.dropdown__skill', 
            '.dropdown__level', 
            '.dropdown__duration',
            '.dropdown__course_type',
        ];

		this.course_template = `<div class="col-mb-12 col-tb-4 col-sm-6 col-lg-4 text-center info-panel-tags__box-cell">
            <div class="info-panel-tags__container  ##DISABLED## bg-white">
                <div class="info-panel-tags__box-content">
                    <div class="info-panel-tags__top">
                        <div class="info-panel-tags__title">
                            <h3 class="grey600">##TITLE##</h3>
                        </div>
                        <div class="info-panel-tags__paragraph">
                            <p class="body-copy grey500 formation__paragraph">##ABSTRACT##</p>
                        </div>
                    </div>

                    <div class="info-panel-tags__center">
                        <div class="info-panel-tags__tags">
                            <ul class="#">
                                <li>
                                    <span>##SKILL##</span>
                                </li>
                                <li>
                                    <span>##LEVEL##</span>
                                </li>
                                <li>
                                    <span>##DURATION##</span>
                                </li>
                                <li>
                                    <span>##COURSE_TYPE##</span>
                                </li>
                            </ul>                            
                        </div>
                    </div>
                    <div class="info-panel-tags__bottom">
                        <div class="info-panel-tags__link">
                            <a href="##URL##" target="_blank" aria-label="Icon Link Light Background" class="links">
                                <span class="ui-show links__icon"></span>##READ_MORE##
                            </a>
                        </div>
                        ##ENROLL_TPL##
                        ##COMPLETE_TPL##
                    </div>
                    <div class="tooltip hide">##UNAVAILABLE##</div>
                </div>
            </div>
        </div>`;

        this.enroll_tpl = `<div class="info-panel-tags__link">
            <a class="button button--primary" href="##ENROLL_LINK##" target="_blank">##ENROLL##</a>
            </div>`;

        this.complete_tpl = `<div class="info-panel-tags__complete">##COMPLETE##</div>`;

		this.events_set = false;
		this.getCourseInfo( { show_all: false, country: null} );
	}

	//getCourseInfo( country = null ){
    getCourseInfo( options = {show_all: false, country: null} ){
		let training_section = document.querySelector(this.selector);

		if( null != training_section && 'undefined' != typeof window.course_data ){
			let current_country = ('undefined' != typeof options && null != options.country)?options.country:'All';
			/* if( null == country && null == Cookies.get('selectedCountry') ) {
				current_country = this.defaultCountry;
			} */
			let body_classes = document.querySelector('body').classList;

			//I don't want this to run if visiting from any other place than formation page
			if( ! (body_classes.contains('template-internal-formation') || body_classes.contains('template-external-formation')) ){ 
				return false;
            }
            
            /**
             * Get Selected filters
             */
            let current_selected_filters = {};
            let all_zeros = true;
            this.arr_filters.forEach( filter => {
                let filter_value = document.querySelector( filter + ' .dropdown__value' ).value;
                current_selected_filters[filter.replace('.dropdown__', '')] = filter_value;

                if( filter_value != '0' ) {
                    all_zeros = false;
                    options.show_all = true;
                    this.cleanFog();
                }
            });

            if( all_zeros && ! options.show_all ) {
                this.addFog();
            }

			let course_template = this.course_template;
            let training_str = '';
            let top_courses = 0;
            let resulting_courses = [];

			if( current_country != 'All' ) {
                top_courses = window.course_data[current_country].length;

                if( null == options.show_all ) {
                    top_courses = window.course_data[current_country].length > this.max_courses_to_show ? this.max_courses_to_show : window.course_data[current_country].length;
                }

                //Filter courses to show
                for( let i = 0; i < top_courses; i++ ) {
                    
                    var item = window.course_data[current_country][i];
                    
                    if( current_selected_filters.skill != '0' && item.skill.name != current_selected_filters.skill ) {
                        continue;
                    }

                    if( current_selected_filters.level != '0' && item.level.name != current_selected_filters.level ) {
                        continue;
                    }

                    if( current_selected_filters.duration != '0' && item.duration.name != current_selected_filters.duration ) {
                        continue;
                    }

                    if( current_selected_filters.course_type != '0' && item.course_type.name != current_selected_filters.course_type ) {
                        continue;
                    }

                    resulting_courses.push( item );
                }
                
                for( let k = 0; k < resulting_courses.length; k++ ) {
                    if( ! options.show_all && resulting_courses.length == this.max_courses_to_show ) {
                        break;
                    }

                    let item = resulting_courses[k];
                    let enroll_tpl = this.enroll_tpl;
                    if( !item.enroll_text ) {
                        enroll_tpl = '';
                    } else {
                        enroll_tpl = enroll_tpl
                        .replace(/##ENROLL##/, item.enroll_text)
                        .replace(/##ENROLL_LINK##/, item.enroll_link)
                    }

                    let complete_tpl = this.complete_tpl;
                    if( !item.complete ) {
                        complete_tpl = '';
                    } else {
                        complete_tpl = complete_tpl
                        .replace(/##COMPLETE##/, window.course_data.complete)
                    }

                    training_str += course_template
                        .replace(/##DISABLED##/, item.course_status?'':'info-panel-tags__disabled')
						.replace(/##URL##/g, item.course_status?item.url:'#')
						.replace(/##TITLE##/g, item.title)
						.replace(/##ABSTRACT##/, item.abstract)
						.replace(/##SKILL##/, item.skill.name)
						.replace(/##LEVEL##/, item.level.name)
						.replace(/##DURATION##/, item.duration.name)
						.replace(/##COURSE_TYPE##/, item.course_type.name)
						.replace(/##UNAVAILABLE##/, item.unavailability_message)
						.replace(/##ENROLL_TPL##/, enroll_tpl)
						.replace(/##COMPLETE##/, complete_tpl)
						.replace(/##READ_MORE##/, window.course_data.read_more);
				}
			} else {
				let all_courses = [];
				for( var key1 in window.course_data ) {
					if( 'object' == typeof window.course_data[key1] ) {
						for( var key2 in window.course_data[key1] ) {
							let item = window.course_data[key1][key2];
							all_courses.push(item);
						}
					}
				}

                all_courses.sort((a,b) => (a.title > b.title) ? 1 : ((b.title > a.title) ? -1 : 0));
                all_courses.sort((a,b) => (a.course_status > b.course_status) ? -1 : ((b.course_status > a.course_status) ? 1 : 0));

                top_courses = all_courses.length;
                if( ! options.show_all ) {
                    top_courses = all_courses.length > this.max_courses_to_show ? this.max_courses_to_show : all_courses.length;
                }

                //Filter courses to show
                for( let j = 0; j < all_courses.length; j++ ) {
                    let course = all_courses[j];
                    if( current_selected_filters.skill != '0' && course.skill.name != current_selected_filters.skill ) {
                        continue;
                    }

                    if( current_selected_filters.level != '0' && course.level.name != current_selected_filters.level ) {
                        continue;
                    }

                    if( current_selected_filters.duration != '0' && course.duration.name != current_selected_filters.duration ) {
                        continue;
                    }

                    if( current_selected_filters.course_type != '0' && course.course_type.name != current_selected_filters.course_type ) {
                        continue;
                    }

                    resulting_courses.push( course );
                }

                //Fill template
                for( let k = 0; k < resulting_courses.length; k++ ) {
                    if( ! options.show_all && k == this.max_courses_to_show ) {
                        break;
                    }
                    let course = resulting_courses[k];
                    let enroll_tpl = this.enroll_tpl;

                    if( !course.enroll_text ) {
                        enroll_tpl = '';
                    } else {
                        enroll_tpl = enroll_tpl
                        .replace(/##ENROLL##/, course.enroll_text)
                        .replace(/##ENROLL_LINK##/, course.enroll_link)
                    }

                    let complete_tpl = this.complete_tpl;
                    if( !course.complete ) {
                        complete_tpl = '';
                    } else {
                        complete_tpl = complete_tpl
                        .replace(/##COMPLETE##/, window.course_data.complete)
                    }

                    training_str += course_template
                        .replace(/##DISABLED##/, course.course_status?'':'info-panel-tags__disabled')
                        .replace(/##URL##/g, course.course_status?course.url:'#')
                        .replace(/##TITLE##/g, course.title)
                        .replace(/##ABSTRACT##/, course.abstract)
                        .replace(/##SKILL##/, course.skill.name)
                        .replace(/##LEVEL##/, course.level.name)
                        .replace(/##DURATION##/, course.duration.name)
                        .replace(/##COURSE_TYPE##/, course.course_type.name)
                        .replace(/##UNAVAILABLE##/, course.unavailability_message)
						.replace(/##ENROLL_TPL##/, enroll_tpl)
						.replace(/##COMPLETE_TPL##/, complete_tpl)
                        .replace(/##READ_MORE##/, window.course_data.read_more);
                }
            }

            if( training_str.length == 0 ) {
                document.querySelector(this.emptyState).classList.remove('hide');
            } else {
                document.querySelector(this.emptyState).classList.add('hide');
            }

            training_section.innerHTML = training_str;

            //Remove target _blank for disabled courses
            training_section.querySelectorAll('.info-panel-tags__disabled').forEach( panel => {
                panel.parentElement.querySelectorAll('a').forEach( link => {
                    link.addEventListener('click', (e) => {
                        e.preventDefault();
                    })
                    link.removeAttribute('target');
                });
            });

            if( ! options.show_all && this.max_courses_to_show < resulting_courses.length ) {
                this.addFog();
            } else if ( options.show_all && this.max_courses_to_show < resulting_courses.length ) {
                this.cleanFog( false );
            } else if( this.max_courses_to_show >= resulting_courses.length ) {
                this.cleanFog( true );
            } else {
                this.cleanFog();
            }

            this.loadPanelEvents();
			if( !this.events_set ) {
				this.loadEvents();
			}
		}
    }
    
    loadPanelEvents() {
        //Add event listener to course items
        let info_panel_tags = document.querySelectorAll( this.selector + ' .info-panel-tags__container');
        for( let i = 0; i < info_panel_tags.length; i++ ){
            if( info_panel_tags[i].classList.contains( 'info-panel-tags__disabled' ) ) {
                let tooltip = info_panel_tags[i].querySelector('.tooltip');
                info_panel_tags[i].addEventListener('mouseover', () => {
                    tooltip.classList.remove('hide');
                });
                info_panel_tags[i].addEventListener('mouseout', () => {
                    tooltip.classList.add('hide');
                });
            }
        }

        /**
         * View all courses event
         */
        let all_courses_link = document.querySelector('.formation__link.view-more a');
        if( null != all_courses_link ) {
            all_courses_link.addEventListener('click', (event) => {
                event.preventDefault();
                if( document.querySelector(this.selector).classList.contains('foggy') ) {
                    this.cleanFog( false );
                }
                this.getCourseInfo({show_all: true, country: null});
            });
        }

        /**
         * View less courses event
         */
        let less_courses_link = document.querySelector('.formation__link.view-less a');
        if( null != less_courses_link ) {
            less_courses_link.addEventListener('click', (event) => {
                event.preventDefault();
                if( ! document.querySelector(this.selector).classList.contains('foggy') ) {
                    this.addFog();
                }
                this.getCourseInfo({show_all: false, country: null});
            });
        }

    }

	loadEvents() {
        /**
         * Filter Events
         */
        document.querySelectorAll(this.arr_filters.join(' .dropdown__menu .item,')).forEach(element => {
            element.addEventListener('mousedown', this.applyFilter.bind(this));
        });

        
        /**
         * View all courses event for empty state
         */
        let all_courses_link_empty_state = document.querySelector('.empty-state a');
        if( null != all_courses_link_empty_state ) {
            all_courses_link_empty_state.addEventListener('click', (event) => {
                event.preventDefault();
                this.cleanFilters();
                this.getCourseInfo({show_all: false, country: null});
            });
        }

        /**
         * Highlighted Courses
         */
        document.querySelectorAll('.training-articles .article-formation__disabled').forEach( article => {
            let tooltip = article.querySelector('.elementor-element.tooltip');
            tooltip.classList.add('hide');
            article.addEventListener('mouseover', () => {
                tooltip.classList.remove('hide');
            });
            article.addEventListener('mouseout', () => {
                tooltip.classList.add('hide');
            });
        });

        /**
         * Show/Hide filters on mobile
         */
        if( screen.width < 960 ) {
            document.querySelector('.formation__select-courses').classList.toggle('hide');
        }
        
        document.querySelector('.formation__filters-mobile a').addEventListener('click', (event) => {
            event.preventDefault();
            document.querySelector('.formation__select-courses').classList.toggle('hide');
        });

        window.addEventListener('resize', () => {
            if( screen.width < 960 ) {
                document.querySelector('.formation__select-courses').classList.toggle('hide');
            }
        });

		this.events_set = true;
    }
    
    applyFilter() {
        this.getCourseInfo({show_all: true, country: null});
    }

    cleanFilters() {
        this.arr_filters.forEach( filter => {
            let item = document.querySelector( filter + ' .dropdown__menu .item' );
            document.querySelector( filter + ' .dropdown__value').setAttribute('value', item.dataset.dropdownValue);
            document.querySelector( filter + ' .dropdown__text').innerHTML = item.innerHTML;
        });
    }

    cleanFog( hide_less = false ) {
        document.querySelector(this.selector).classList.remove('foggy');
        document.querySelector('.formation__link.view-more').parentElement.classList.add('hide');
        if( hide_less ) {
            document.querySelector('.formation__link.view-less').parentElement.classList.add('hide');
        } else {
            document.querySelector('.formation__link.view-less').parentElement.classList.remove('hide');
        }
    }

    addFog() {
        document.querySelector(this.selector).classList.add('foggy');
        //document.querySelector('.formation__link').parentElement.classList.remove('hide');
        document.querySelector('.formation__link.view-more').parentElement.classList.remove('hide');
        document.querySelector('.formation__link.view-less').parentElement.classList.add('hide');
    }
}

export default Course